export class Action {
    canView = false;
    canCreate = false;
    canDelete = false;
    canUpdate = false;
    canReport = false;
    canApprove = false;
}
